export function validationRFC(rfc: string) {
  const RegexRFC = /^(?=.*[A-ZÑ&])(?=.*[0-9])(?:[A-ZÑ&]{3,4})(?:[0-9]{2})(?:(?:0[1-9]|1[0-2])(?:0[1-9]|1\d|2[0-9]|3[0-1])|(?:0[13-9]|1[0-2])(?:30)|(?:0[1-9]|1[0-2])(?:0[1-9]|1\d|2[0-8]))(?:[A-Z\d]{2})(?:[0-9A])?$/;

  return RegexRFC.test(rfc);
}
